module.exports = __webpack_public_path__ + "static/img/pic200-13.4fedcce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic200-13.png
// module id = agKm
// module chunks = 31